module.exports = __webpack_public_path__ + "static/media/rhino.f47c52b9.png";